export default function initVideo() {
    const facades = document.querySelectorAll('.js-video-facade');

    if (!facades.length) return;

    facades.forEach(facade => {
        facade.addEventListener('click', function () {
            const videoUrl = this.getAttribute('data-src');

            // Cria o iframe do YouTube
            const iframe = document.createElement('iframe');
            iframe.setAttribute('src', videoUrl);
            iframe.setAttribute('frameborder', '0');
            iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
            iframe.setAttribute('allowfullscreen', 'true');

            // Limpa a capa e o botão, e injeta o iframe
            this.innerHTML = '';
            this.appendChild(iframe);

            // Remove a classe para não clicar de novo
            this.classList.remove('js-video-facade');
            this.style.cursor = 'default';
        });
    });
}